import { useState, useEffect } from "react";
import { db, storage } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [editId, setEditId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [loading, setLoading] = useState(false);

  // Load danh sách sản phẩm
  const fetchProducts = async () => {
    const querySnapshot = await getDocs(collection(db, "products"));
    setProducts(querySnapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let uploadedImageUrl = imageUrl;

    // Nếu có file ảnh mới thì upload
    if (imageFile) {
      const storageRef = ref(storage, `products/${Date.now()}-${imageFile.name}`);
      await uploadBytes(storageRef, imageFile);
      uploadedImageUrl = await getDownloadURL(storageRef);
    }

    const data = {
      title,
      price: Number(price),
      image: uploadedImageUrl,
    };

    if (editId) {
      await updateDoc(doc(db, "products", editId), data);
    } else {
      await addDoc(collection(db, "products"), data);
    }

    // Reset form
    setTitle("");
    setPrice("");
    setImageFile(null);
    setImageUrl("");
    setPreviewUrl("");
    setEditId(null);
    setLoading(false);

    fetchProducts();
  };

  const handleEdit = (product) => {
    setTitle(product.title);
    setPrice(product.price);
    setImageUrl(product.image);
    setPreviewUrl(product.image);
    setEditId(product.id);
    setImageFile(null);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "products", id));
    fetchProducts();
  };

  return (
    <div
      className="container mt-5"
      style={{
        maxWidth: "700px",
        margin: "5 auto",
        paddingTop: "70px",
      }}
    >
      <h2>Quản lý sản phẩm</h2>

      <form onSubmit={handleSubmit} className="mb-4">
        <input
          type="text"
          placeholder="Tên sản phẩm"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          className="form-control mb-2"
        />
        <input
          type="number"
          placeholder="Giá"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
          className="form-control mb-2"
        />

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="form-control mb-2"
        />

        {previewUrl && (
          <div className="mb-2">
            <p>Preview ảnh:</p>
            <img
              src={previewUrl}
              alt="Preview"
              width="120"
              style={{ border: "1px solid #ccc" }}
            />
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Đang lưu..." : editId ? "Cập nhật" : "Thêm mới"}
        </button>
      </form>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Ảnh</th>
            <th>Tên</th>
            <th>Giá</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.id}>
              <td>
                {p.image && (
                  <img
                    src={p.image}
                    alt={p.title}
                    width="80"
                    style={{ objectFit: "cover" }}
                  />
                )}
              </td>
              <td>{p.title}</td>
              <td>{p.price.toLocaleString()}₫</td>
              <td>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => handleEdit(p)}
                >
                  Sửa
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(p.id)}
                >
                  Xóa
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminProducts;
